
export const YOUTUBE_SCRIPTS = [
    {
        id: "yt-tutorial-classico",
        title: { pt: "Tutorial Passo a Passo", en: "Step-by-Step Tutorial", es: "Tutorial Paso a Paso" },
        tags: ["YouTube", "Tutorial", "Educação"],
        content: {
            pt: `<r>GANCHO (0-15s)</r>
Você quer aprender a [RESULTADO DESEJADO] sem precisar [DOR COMUM]?
No vídeo de hoje, eu vou te ensinar o passo a passo exato para [TÓPICO] em apenas [TEMPO/PASSOS].
Se você sempre teve dificuldade com [OBJEÇÃO], fica comigo até o final porque a última dica vai mudar o seu jogo.
<g>INTRODUÇÃO (15-45s)</r>
Fala galera, aqui é o [SEU NOME] e bem-vindos a mais um vídeo.
Antes de começarmos, já deixa o like se você gosta de conteúdo sobre [NICHO], isso ajuda muito o canal.
<y>CONTEÚDO - PASSO 1</r>
O primeiro passo é [AÇÃO 1].
Muita gente erra aqui porque tenta [ERRO COMUM]. Não faça isso.
O segredo é focar em [DICA CHAVE].
<y>CONTEÚDO - PASSO 2</r>
Agora que você já fez a base, vamos para [AÇÃO 2].
Aqui você vai notar que [DETALHE IMPORTANTE].
<y>CONTEÚDO - PASSO 3</r>
Por fim, o toque final: [AÇÃO 3].
Veja como o resultado fica incrível quando você aplica essa técnica.
<g>CONCLUSÃO E CTA</r>
E aí, o que achou? Muito mais simples do que parecia, né?
Agora eu quero saber de você: qual a sua maior dúvida sobre [TÓPICO]? Comenta aqui embaixo.
Não esquece de se inscrever para não perder o próximo vídeo sobre [PRÓXIMO TEMA].
Te vejo na próxima!`,
            en: `<r>HOOK (0-15s)</r>
Do you want to learn how to [DESIRED RESULT] without having to [COMMON PAIN]?
In today's video, I'm going to teach you the exact step-by-step to [TOPIC] in just [TIME/STEPS].
If you've always struggled with [OBJECTION], stay with me until the end because the last tip will change your game.
<g>INTRO (15-45s)</r>
Hey everyone, it's [YOUR NAME] here and welcome to another video.
Before we start, smash that like button if you enjoy content about [NICHE], it really helps the channel.
<y>CONTENT - STEP 1</r>
The first step is [ACTION 1].
Many people mistake here because they try to [COMMON MISTAKE]. Don't do that.
The secret is to focus on [KEY TIP].
<y>CONTENT - STEP 2</r>
Now that you've done the foundation, let's move to [ACTION 2].
Here you'll notice that [IMPORTANT DETAIL].
<y>CONTENT - STEP 3</r>
Finally, the finishing touch: [ACTION 3].
See how amazing the result looks when you apply this technique.
<g>CONCLUSION & CTA</r>
So, what did you think? Much simpler than it seemed, right?
Now I want to hear from you: what's your biggest question about [TOPIC]? Comment down below.
Don't forget to subscribe so you don't miss the next video about [NEXT TOPIC].
See you in the next one!`,
            es: `<r>GANCHO (0-15s)</r>
¿Quieres aprender a [RESULTADO DESEADO] sin tener que [DOLOR COMÚN]?
En el video de hoy, te voy a enseñar el paso a paso exacto para [TEMA] en solo [TIEMPO/PASOS].
Si siempre has tenido dificultades con [OBJECIÓN], quédate conmigo hasta el final porque el último consejo cambiará tu juego.
<g>INTRODUCCIÓN (15-45s)</r>
Hola a todos, soy [TU NOMBRE] y bienvenidos a otro video.
Antes de empezar, dale like si te gusta el contenido sobre [NICHO], eso ayuda mucho al canal.
<y>CONTENIDO - PASO 1</r>
El primer paso es [ACCIÓN 1].
Mucha gente se equivoca aquí porque intenta [ERROR COMÚN]. No hagas eso.
El secreto es enfocarse en [CONSEJO CLAVE].
<y>CONTENIDO - PASO 2</r>
Ahora que has hecho la base, vamos a [ACCIÓN 2].
Aquí notarás que [DETALLE IMPORTANTE].
<y>CONTENIDO - PASO 3</r>
Finalmente, el toque final: [ACCIÓN 3].
Mira qué increíble queda el resultado cuando aplicas esta técnica.
<g>CONCLUSIÓN Y CTA</r>
Entonces, ¿qué te pareció? Mucho más simple de lo que parecía, ¿verdad?
Ahora quiero saber de ti: ¿cuál es tu mayor duda sobre [TEMA]? Comenta aquí abajo.
No olvides suscribirte para no perderte el próximo video sobre [PRÓXIMO TEMA].
¡Nos vemos en el próximo!`
        }
    },
    {
        id: "yt-listicle",
        title: { pt: "Lista / Top 5 Melhores", en: "Listicle / Top 5 Best", es: "Lista / Top 5 Mejores" },
        tags: ["YouTube", "Review", "Lista"],
        content: {
            pt: `<r>GANCHO</r>
Você está em dúvida sobre qual [PRODUTO] comprar em 2024?
Eu testei os 5 melhores modelos do mercado e vou te contar qual realmente vale o seu dinheiro e qual é pura propaganda.
O terceiro item dessa lista vai te surpreender.
<g>INTRO</r>
Bem-vindos ao canal! Eu sou [NOME] e hoje vamos fazer um comparativo definitivo de [CATEGORIA].
Analisei preço, qualidade e durabilidade para você não jogar dinheiro fora.
Vamos direto ao ponto.
<y>ITEM 5 - O MAIS BARATO</r>
Em quinto lugar, temos o [PRODUTO 5].
Ele é ideal para quem está começando e não quer gastar muito.
PONTOS POSITIVOS: [PONTO 1], [PONTO 2].
PONTOS NEGATIVOS: [DEFEITO].
<y>ITEM 4 - O MELHOR CUSTO-BENEFÍCIO</r>
Subindo a lista, o [PRODUTO 4] entrega muito por um preço justo.
Se você quer [BENEFÍCIO], essa é a escolha.
<y>ITEM 3 - A SURPRESA (POLÊMICO)</r>
Agora, o que ninguém te conta. O [PRODUTO 3] promete muito, mas...
<y>ITEM 2 - O PROFISSIONAL</r>
Se você tem orçamento, o [PRODUTO 2] é a máquina definitiva.
<g>ITEM 1 - O CAMPEÃO GERAL</r>
E o grande vencedor é o [PRODUTO 1].
Ele combina [QUALIDADE] com [PREÇO] de uma forma imbatível. A bateria dura [TEMPO] e o acabamento é premium.
<r>CONCLUSÃO</r>
Vou deixar o link de todos eles aqui na descrição.
Qual desses você compraria? Me conta nos comentários!`,
            en: `<r>HOOK</r>
Are you unsure about which [PRODUCT] to buy in 2024?
I tested the 5 best models on the market and I'll tell you which one is really worth your money and which is pure hype.
The third item on this list will surprise you.
<g>INTRO</r>
Welcome to the channel! I'm [NAME] and today we're doing a definitive comparison of [CATEGORY].
I analyzed price, quality, and durability so you don't waste money.
Let's get straight to the point.
<y>ITEM 5 - THE CHEAPEST</r>
In fifth place, we have [PRODUCT 5].
It's ideal for beginners who don't want to spend much.
PROS: [POINT 1], [POINT 2].
CONS: [FLAW].
<y>ITEM 4 - THE BEST VALUE</r>
Moving up the list, [PRODUCT 4] delivers a lot for a fair price.
If you want [BENEFIT], this is the choice.
<y>ITEM 3 - THE SURPRISE (CONTROVERSIAL)</r>
Now, what no one tells you. [PRODUCT 3] promises a lot, but...
<y>ITEM 2 - THE PROFESSIONAL</r>
If you have the budget, [PRODUCT 2] is the ultimate machine.
<g>ITEM 1 - THE OVERALL CHAMPION</r>
And the big winner is [PRODUCT 1].
It combines [QUALITY] with [PRICE] in an unbeatable way. The battery lasts [TIME] and the finish is premium.
<r>CONCLUSION</r>
I'll leave the link to all of them in the description.
Which one would you buy? Tell me in the comments!`,
            es: `<r>GANCHO</r>
¿Estás dudando sobre qué [PRODUCTO] comprar en 2024?
Probé los 5 mejores modelos del mercado y te contaré cuál realmente vale tu dinero y cuál es pura propaganda.
El tercer artículo de esta lista te sorprenderá.
<g>INTRO</r>
¡Bienvenidos al canal! Soy [NOMBRE] y hoy haremos una comparación definitiva de [CATEGORÍA].
Analicé precio, calidad y durabilidad para que no tires dinero a la basura.
Vamos directo al grano.
<y>ÍTEM 5 - EL MÁS BARATO</r>
En quinto lugar, tenemos el [PRODUCTO 5].
Es ideal para quienes empiezan y no quieren gastar mucho.
PUNTOS POSITIVOS: [PUNTO 1], [PUNTO 2].
PUNTOS NEGATIVOS: [DEFECTO].
<y>ÍTEM 4 - MEJOR COSTO-BENEFICIO</r>
Subiendo en la lista, el [PRODUCTO 4] entrega mucho por un precio justo.
Si quieres [BENEFICIO], esta es la elección.
<y>ÍTEM 3 - LA SORPRESA (POLÉMICO)</r>
Ahora, lo que nadie te cuenta. El [PRODUCTO 3] promete mucho, pero...
<y>ÍTEM 2 - EL PROFESIONAL</r>
Si tienes presupuesto, el [PRODUCTO 2] es la máquina definitiva.
<g>ÍTEM 1 - EL CAMPEÓN GENERAL</r>
Y el gran ganador es el [PRODUCTO 1].
Combina [CALIDAD] con [PRECIO] de una forma imbatible. La batería dura [TIEMPO] y el acabado es premium.
<r>CONCLUSIÓN</r>
Dejaré el enlace de todos ellos en la descripción.
¿Cuál de estos comprarías? ¡Cuéntame en los comentarios!`
        }
    },
    {
        id: "yt-vlog-viagem",
        title: { pt: "Vlog de Viagem / Diário", en: "Travel Vlog / Daily", es: "Vlog de Viaje / Diario" },
        tags: ["YouTube", "Vlog", "Lifestyle"],
        content: {
            pt: `<r>INTRODUÇÃO (CINEMÁTICA)</r>
(Comece com cenas rápidas do lugar incrível onde você está)
Bom dia, pessoal! Olha só onde a gente amanheceu hoje.
Eu esperei [TEMPO] por essa viagem e finalmente chegamos em [LUGAR].
Hoje o dia vai ser intenso: vamos visitar [PONTO TURÍSTICO 1] e tentar comer o famoso [PRATO TÍPICO].
<y>DESENVOLVIMENTO - MANHÃ</r>
Agora são 09:00 e estamos saindo do hotel.
Uma dica rápida pra quem vem pra cá: evite [ERRO TURÍSTICO].
Vem comigo ver isso aqui...
(Mostrando o local)
É inacreditável a cor dessa água/arquitetura.
<y>O CLÍMAX (PERRENGUE OU SURPRESA)</r>
Nem tudo são flores... olha o que acabou de acontecer.
[DESCREVER IMPREVISTO].
Mas a gente não vai deixar isso estragar o dia. Vamos improvisar e ir para [PLANO B].
<g>CONCLUSÃO</r>
Que dia! Estou exausto mas valeu cada segundo.
O melhor momento pra mim foi [MOMENTO].
Se você gostou de passar esse dia comigo, deixa o like.
Semana que vem a gente vai para [PRÓXIMO DESTINO]. Ativa o sininho pra não perder!`,
            en: `<r>INTRO (CINEMATIC)</r>
(Start with quick cuts of the amazing place you are)
Good morning guys! Look where we woke up today.
I've waited [TIME] for this trip and we finally arrived in [PLACE].
Today is going to be intense: we're visiting [LANDMARK 1] and trying to eat the famous [LOCAL DISH].
<y>DEVELOPMENT - MORNING</r>
It's 9:00 AM now and we're leaving the hotel.
Quick tip for anyone coming here: avoid [TOURIST MISTAKE].
Come check this out...
(Showing the spot)
The color of this water/architecture is unbelievable.
<y>THE CLIMAX (SURPRISE OR HASSLE)</r>
It's not all sunshine... look what just happened.
[DESCRIBE EVENT].
But we won't let this ruin the day. We're improvising and going to [PLAN B].
<g>CONCLUSION</r>
What a day! I'm exhausted but it was worth every second.
The best moment for me was [MOMENT].
If you enjoyed spending this day with me, drop a like.
Next week we're off to [NEXT DESTINATION]. Hit the bell so you don't miss it!`,
            es: `<r>INTRODUCCIÓN (CINEMÁTICA)</r>
(Empieza con escenas rápidas del lugar increíble donde estás)
¡Buenos días a todos! Miren dónde amanecimos hoy.
Esperé [TIEMPO] por este viaje y finalmente llegamos a [LUGAR].
Hoy será intenso: visitaremos [PUNTO TURÍSTICO 1] e intentaremos comer el famoso [PLATO TÍPICO].
<y>DESARROLLO - MAÑANA</r>
Son las 09:00 y salimos del hotel.
Consejo rápido para quien venga: eviten [ERROR TURÍSTICO].
Ven a ver esto...
(Mostrando el lugar)
Es increíble el color de esta agua/arquitectura.
<y>EL CLÍMAX (IMPREVISTO O SORPRESA)</r>
No todo es color de rosa... miren lo que acaba de pasar.
[DESCRIBIR EVENTO].
Pero no dejaremos que esto arruine el día. Vamos a improvisar e ir al [PLAN B].
<g>CONCLUSIÓN</r>
¡Qué día! Estoy agotado pero valió cada segundo.
El mejor momento para mí fue [MOMENTO].
Si te gustó pasar este día conmigo, dale like.
La próxima semana vamos a [PRÓXIMO DESTINO]. ¡Activa la campanita para no perderte nada!`
        }
    },
    {
        id: "yt-storytelling",
        title: { pt: "Storytelling Emocional", en: "Emotional Storytelling", es: "Storytelling Emocional" },
        tags: ["YouTube", "História", "Inspiração"],
        content: {
            pt: `<r>GANCHO (O PONTO DE VIRADA)</r>
Foi nesse exato momento que eu percebi que tinha perdido tudo.
Eu estava sentado em [LUGAR], com apenas [QUANTIA] no bolso, e não sabia para onde ir.
Mas essa não é uma história triste. É a história de como eu dei a volta por cima.
<g>ATO 1 - O CONTEXTO</r>
Tudo começou em [ANO], quando eu decidi [DECISÃO ARRISCADA].
Parecia o plano perfeito. Todo mundo dizia que ia dar certo.
Mas eu ignorei um detalhe crucial: [O ERRO].
<y>ATO 2 - O FUNDO DO POÇO</r>
De repente, as coisas começaram a desmoronar.
Primeiro foi [PROBLEMA 1]. Depois [PROBLEMA 2].
Eu me senti [SENTIMENTO]. Pensei em desistir várias vezes.
<y>ATO 3 - A REVELAÇÃO</r>
Até que eu conheci [MENTOR/LIVRO/IDEIA].
Foi como se uma luz acendesse. Eu entendi que não precisava de [COISA], mas sim de [SOLUÇÃO].
Comecei a aplicar isso dia após dia.
<g>CONCLUSÃO - A VITÓRIA</r>
Hoje, olhando para trás, eu agradeço por aquele fracasso.
Se você está passando por algo difícil agora, lembre-se: [LIÇÃO MORAL].
O sucesso não é uma linha reta.
Compartilhe sua história nos comentários, eu quero ler.`,
            en: `<r>HOOK (THE TURNING POINT)</r>
It was at that exact moment I realized I had lost everything.
I was sitting in [PLACE], with only [AMOUNT] in my pocket, and nowhere to go.
But this isn't a sad story. It's the story of how I bounced back.
<g>ACT 1 - THE CONTEXT</r>
It all started in [YEAR], when I decided to [RISKY DECISION].
It seemed like the perfect plan. Everyone said it would work.
But I ignored one crucial detail: [THE MISTAKE].
<y>ACT 2 - ROCK BOTTOM</r>
Suddenly, things started falling apart.
First it was [PROBLEM 1]. Then [PROBLEM 2].
I felt [FEELING]. I thought about giving up multiple times.
<y>ACT 3 - THE REVELATION</r>
Until I met [MENTOR/BOOK/IDEA].
It was like a light turned on. I understood I didn't need [THING], but rather [SOLUTION].
I started applying this day after day.
<g>CONCLUSION - THE VICTORY</r>
Today, looking back, I'm grateful for that failure.
If you're going through something hard right now, remember: [MORAL LESSON].
Success is not a straight line.
Share your story in the comments, I want to read it.`,
            es: `<r>GANCHO (EL PUNTO DE INFLEXIÓN)</r>
Fue en ese exacto momento que me di cuenta de que lo había perdido todo.
Estaba sentado en [LUGAR], con solo [CANTIDAD] en el bolsillo, y no sabía a dónde ir.
Pero esta no es una historia triste. Es la historia de cómo me recuperé.
<g>ACTO 1 - EL CONTEXTO</r>
Todo comenzó en [AÑO], cuando decidí [DECISIÓN ARRIESGADA].
Parecía el plan perfecto. Todos decían que funcionaría.
Pero ignoré un detalle crucial: [EL ERROR].
<y>ACTO 2 - TOCAR FONDO</r>
De repente, las cosas empezaron a desmoronarse.
Primero fue [PROBLEMA 1]. Luego [PROBLEMA 2].
Me sentí [SENTIMIENTO]. Pensé en rendirme varias veces.
<y>ACTO 3 - LA REVELACIÓN</r>
Hasta que conocí [MENTOR/LIBRO/IDEA].
Fue como si se encendiera una luz. Entendí que no necesitaba [COSA], sino [SOLUCIÓN].
Empecé a aplicar esto día tras día.
<g>CONCLUSIÓN - LA VICTORIA</r>
Hoy, mirando atrás, agradezco ese fracaso.
Si estás pasando por algo difícil ahora, recuerda: [LECCIÓN MORAL].
El éxito no es una línea recta.
Comparte tu historia en los comentarios, quiero leerla.`
        }
    },
    {
        id: "yt-news-commentary",
        title: { pt: "Comentário de Notícia / Opinião", en: "News Commentary / Opinion", es: "Comentario de Noticias / Opinión" },
        tags: ["YouTube", "Opinião", "Atualidades"],
        content: {
            pt: `<r>MANCHETE (GANCHO)</r>
Você viu o que acabou de acontecer com [ASSUNTO DO MOMENTO]?
Isso vai mudar completamente a forma como a gente [AÇÃO].
Se você acha que é exagero, espera só até ver esse dado aqui.
<y>O FATO</r>
Saiu hoje a notícia de que [FONTE] confirmou [ACONTECIMENTO].
Basicamente, isso significa que [EXPLICAÇÃO SIMPLES].
Mas tem um detalhe que ninguém está falando.
<y>MINHA ANÁLISE</r>
Na minha opinião, isso é [BOM/RUIM] porque [ARGUMENTO 1].
Olha o histórico: em 2018 aconteceu a mesma coisa e o resultado foi [HISTÓRICO].
Por que seria diferente agora?
<y>O OUTRO LADO</r>
Claro, tem gente dizendo que [CONTRA-ARGUMENTO].
Faz sentido, mas não podemos ignorar [FATO IRREFUTÁVEL].
<g>CONCLUSÃO</r>
O que você acha? É o fim de [COISA] ou um novo começo?
Deixa sua opinião polêmica aqui embaixo, quero ver o circo pegar fogo.
Se inscreve pra acompanhar o desenrolar dessa história.`,
            en: `<r>HEADLINE (HOOK)</r>
Did you see what just happened with [TRENDING TOPIC]?
This will completely change the way we [ACTION].
If you think I'm exaggerating, just wait until you see this data here.
<y>THE FACT</r>
News broke today that [SOURCE] confirmed [EVENT].
Basically, this means that [SIMPLE EXPLANATION].
But there is a detail that no one is talking about.
<y>MY ANALYSIS</r>
In my opinion, this is [GOOD/BAD] because [ARGUMENT 1].
Look at history: in 2018 the same thing happened and the result was [HISTORY].
Why would it be different now?
<y>THE OTHER SIDE</r>
Of course, some people are saying [COUNTER-ARGUMENT].
It makes sense, but we cannot ignore [IRREFUTABLE FACT].
<g>CONCLUSION</r>
What do you think? Is this the end of [THING] or a new beginning?
Leave your controversial opinion below, I want to see the debate.
Subscribe to follow the development of this story.`,
            es: `<r>TITULAR (GANCHO)</r>
¿Viste lo que acaba de pasar con [TEMA DEL MOMENTO]?
Esto cambiará completamente la forma en que [ACCIÓN].
Si crees que es exagerado, espera a ver este dato aquí.
<y>EL HECHO</r>
Salió hoy la noticia de que [FUENTE] confirmó [ACONTECIMIENTO].
Básicamente, esto significa que [EXPLICACIÓN SIMPLE].
Pero hay un detalle del que nadie está hablando.
<y>MI ANÁLISIS</r>
En mi opinión, esto es [BUENO/MALO] porque [ARGUMENTO 1].
Mira la historia: en 2018 pasó lo mismo y el resultado fue [HISTORIA].
¿Por qué sería diferente ahora?
<y>EL OTRO LADO</r>
Claro, hay gente diciendo que [CONTRA-ARGUMENTO].
Tiene sentido, pero no podemos ignorar [HECHO IRREFUTABLE].
<g>CONCLUSIÓN</r>
¿Qué opinas? ¿Es el fin de [COSA] o un nuevo comienzo?
Deja tu opinión polémica aquí abajo, quiero ver el debate.
Suscríbete para seguir el desarrollo de esta historia.`
        }
    },
    {
        id: "yt-qa-session",
        title: { pt: "Sessão de Perguntas e Respostas (Q&A)", en: "Q&A Session", es: "Sesión de Preguntas y Respuestas" },
        tags: ["YouTube", "Engajamento", "Comunidade"],
        content: {
            pt: `<r>ABERTURA</r>
Vocês perguntaram, e eu estou aqui para responder!
No vídeo de hoje: "Quanto eu ganho?", "Como começar do zero?" e a polêmica "Vale a pena fazer [COISA]?"
A pergunta número 4 foi a mais pedida no Instagram.
<g>PERGUNTA 1</r>
A @usuario123 perguntou: [PERGUNTA 1].
Ótima pergunta. A verdade é que [RESPOSTA HONESTA].
Eu demorei [TEMPO] para aprender isso.
<y>PERGUNTA 2</r>
O @outro.cara quer saber: [PERGUNTA 2].
Depende. Se você for [PERFIL A], sim. Se for [PERFIL B], fuja disso.
O meu conselho é: [CONSELHO PRÁTICO].
<y>PERGUNTA 3 (A POLÊMICA)</r>
E agora, a que todo mundo quer saber. [PERGUNTA 3].
Olha, vou ser bem sincero com vocês.
[RESPOSTA DETALHADA E CONTROVERSA].
<g>ENCERRAMENTO</r>
Gostaram desse formato?
Se a sua pergunta não apareceu aqui, coloca ela nos comentários agora que eu vou responder as 10 primeiras.
Não esquece do like!`,
            en: `<r>OPENING</r>
You asked, and I'm here to answer!
In today's video: "How much do I make?", "How to start from scratch?" and the controversial "Is it worth doing [THING]?"
Question number 4 was the most requested on Instagram.
<g>QUESTION 1</r>
@user123 asked: [QUESTION 1].
Great question. The truth is that [HONEST ANSWER].
It took me [TIME] to learn this.
<y>QUESTION 2</r>
@other.guy wants to know: [QUESTION 2].
It depends. If you are [PROFILE A], yes. If you are [PROFILE B], run away from it.
My advice is: [PRACTICAL ADVICE].
<y>QUESTION 3 (THE CONTROVERSIAL ONE)</r>
And now, the one everyone wants to know. [QUESTION 3].
Look, I'm going to be very honest with you.
[DETAILED AND CONTROVERSIAL ANSWER].
<g>CLOSING</r>
Did you like this format?
If your question didn't appear here, put it in the comments now and I'll answer the first 10.
Don't forget the like!`,
            es: `<r>APERTURA</r>
¡Ustedes preguntaron, y yo estoy aquí para responder!
En el video de hoy: "¿Cuánto gano?", "¿Cómo empezar de cero?" y la polémica "¿Vale la pena hacer [COSA]?"
La pregunta número 4 fue la más pedida en Instagram.
<g>PREGUNTA 1</r>
@usuario123 preguntó: [PREGUNTA 1].
Gran pregunta. La verdad es que [RESPUESTA HONESTA].
Me tomó [TIEMPO] aprender esto.
<y>PREGUNTA 2</r>
@otro.tipo quiere saber: [PREGUNTA 2].
Depende. Si eres [PERFIL A], sí. Si eres [PERFIL B], huye de eso.
Mi consejo es: [CONSEJO PRÁCTICO].
<y>PREGUNTA 3 (LA POLÉMICA)</r>
Y ahora, la que todos quieren saber. [PREGUNTA 3].
Mira, voy a ser muy sincero con ustedes.
[RESPUESTA DETALLADA Y CONTROVERSIAL].
<g>CIERRE</r>
¿Les gustó este formato?
Si tu pregunta no apareció aquí, ponla en los comentarios ahora y responderé las primeras 10.
¡No olviden el like!`
        }
    },
    {
        id: "yt-channel-update",
        title: { pt: "Atualização de Canal / Milestone", en: "Channel Update / Milestone", es: "Actualización del Canal / Hito" },
        tags: ["YouTube", "Vlog", "Agradecimento"],
        content: {
            pt: `<r>O FIM DE UMA ERA?</r>
Eu preciso falar com vocês.
Muita coisa está mudando aqui no canal e eu senti que devia uma explicação.
Mas calma, é uma notícia boa (eu acho).
<g>A CONQUISTA</r>
Chegamos a [NÚMERO] inscritos!
Isso é surreal. Eu lembro quando comecei gravando com [EQUIPAMENTO RUIM] no meu quarto.
Obrigado a cada um de vocês que acredita no meu trabalho.
<y>O FUTURO</r>
O que vai acontecer agora?
Eu decidi focar mais em [NOVO FOCO] e menos em [ANTIGO FOCO].
O motivo é simples: [MOTIVO PESSOAL/ESTRATÉGICO].
Também vamos ter vídeos novos toda [DIA DA SEMANA].
<g>PEDIDO ESPECIAL</r>
Eu queria pedir uma opinião.
Vocês preferem que eu continue com a série [SÉRIE ANTIGA] ou comece algo novo sobre [NOVO TEMA]?
Votem na enquete aí em cima ou comentem.
Obrigado por tudo, família!`,
            en: `<r>THE END OF AN ERA?</r>
I need to talk to you guys.
A lot is changing here on the channel and I felt I owed you an explanation.
But calm down, it's good news (I think).
<g>THE ACHIEVEMENT</r>
We reached [NUMBER] subscribers!
This is surreal. I remember when I started recording with [BAD EQUIPMENT] in my bedroom.
Thank you to each one of you who believes in my work.
<y>THE FUTURE</r>
What happens now?
I decided to focus more on [NEW FOCUS] and less on [OLD FOCUS].
The reason is simple: [PERSONAL/STRATEGIC REASON].
We will also have new videos every [DAY OF THE WEEK].
<g>SPECIAL REQUEST</r>
I wanted to ask for an opinion.
Do you prefer I continue with the [OLD SERIES] series or start something new about [NEW TOPIC]?
Vote in the poll up there or comment.
Thanks for everything, family!`,
            es: `<r>¿EL FIN DE UNA ERA?</r>
Necesito hablar con ustedes.
Muchas cosas están cambiando aquí en el canal y sentí que les debía una explicación.
Pero tranquilos, es una buena noticia (creo).
<g>EL LOGRO</r>
¡Llegamos a [NÚMERO] suscriptores!
Esto es surrealista. Recuerdo cuando empecé grabando con [EQUIPO MALO] en mi habitación.
Gracias a cada uno de ustedes que cree en mi trabajo.
<y>EL FUTURO</r>
¿Qué pasará ahora?
Decidí enfocarme más en [NUEVO ENFOQUE] y menos en [ANTIGUO ENFOQUE].
La razón es simple: [MOTIVO PERSONAL/ESTRATÉGICO].
También tendremos videos nuevos cada [DÍA DE LA SEMANA].
<g>PEDIDO ESPECIAL</r>
Quería pedir una opinión.
¿Prefieren que continúe con la serie [SERIE ANTIGUA] o empiece algo nuevo sobre [NUEVO TEMA]?
Voten en la encuesta de arriba o comenten.
¡Gracias por todo, familia!`
        }
    }
];
